var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.inited)?_c('div',[_c('router-view',{ref:"main-component"})],1):_vm._e(),_c('ConfirmationDialog'),(_vm.isStoreBusy)?_c('div',[_c('Loading')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }